import { Component } from '@angular/core';

@Component({
  selector: 'ama-ng-upp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true
})
export class FooterComponent {
  constructor() {}
}
